import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as decisionsToImposeFineServiceClear } from './decisionsToImposeFineService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'decisionsToImposeFine',
  serviceTableName: 'decisionsToImposeFineService',
  serviceClearFunction: decisionsToImposeFineServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.decisionToImposeFine]),
});
